import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { getCategoryName } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 4);

  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-12 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-600">专业团队精心编写的健康科普内容</p>
          </div>
          <Link
            to="/category/bladder-health"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-primary-500/90 text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {getCategoryName(article.category)}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{article.publishDate}</span>
                  <span className="whitespace-nowrap">{article.readTime}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}